import { createAction, props } from '@ngrx/store';
import { ApplicationListItem } from '../../interfaces/application-list-item';

export const loadApplications = createAction(
  '[Application/API] Load Applications'
);

export const loadApplicationsSuccess = createAction(
  '[Application/API] Load Applications Success',
  props<{ applications: ApplicationListItem[] }>()
);

export const loadApplicationsFailure = createAction(
  '[Application/API] Load Applications Failure',
  props<{ error: any }>()
);

export const createApplication = createAction(
  '[Application/API] Create Application',
  props<{ application: Exclude<ApplicationListItem, 'id'> }>()
);

export const createApplicationSuccess = createAction(
  '[Application/API] Create Application Success',
  props<{ application: ApplicationListItem }>()
);

export const createApplicationFailure = createAction(
  '[Application/API] Create Application Failure',
  props<{ error: any }>()
);

export const updateApplication = createAction(
  '[Application/API] Update Application',
  props<{ application: ApplicationListItem; index?: number }>()
);

export const updateApplicationSuccess = createAction(
  '[Application/API] Update Application Success',
  props<{ application: ApplicationListItem }>()
);

export const updateApplicationFailure = createAction(
  '[Application/API] Update Application Failure',
  props<{ error: any }>()
);

export const deleteApplication = createAction(
  '[Application/API] Delete Application',
  props<{ application: ApplicationListItem }>()
);

export const deleteApplicationSuccess = createAction(
  '[Application/API] Delete Application Success',
  props<{ id: number }>()
);

export const deleteApplicationFailure = createAction(
  '[Application/API] Delete Application Failure',
  props<{ error: any }>()
);

export const clearApplications = createAction('[Application/API] Clear Applications');
